import { render, staticRenderFns } from "./SummarySemesterRow.vue?vue&type=template&id=042f08f8&scoped=true"
import script from "./SummarySemesterRow.vue?vue&type=script&lang=js"
export * from "./SummarySemesterRow.vue?vue&type=script&lang=js"
import style0 from "./SummarySemesterRow.vue?vue&type=style&index=0&id=042f08f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042f08f8",
  null
  
)

export default component.exports